import React from "react";
import trim from "lodash/trim";
import split from "lodash/split";
import uniq from "lodash/uniq";
import isEmpty from "lodash/isEmpty";
import isArray from "lodash/isArray";
import last from "lodash/last";
import slice from "lodash/slice";
import LicenseCheck from "license/LicenseCheck";
import UserNotification from "util/UserNotification";
import { Button, ButtonToolbar, Col, Row, Table, Input } from "components/bootstrap";
import { PaginatedList, SearchForm, TimeUnitInput, Timestamp } from "components/common";
import ObjectUtils from "util/ObjectUtils";
import connect from "stores/connect";
import { MongoDBDataAdapterStore, MongoDBDataAdapterActions } from "../stores/MongoDBDataAdapterStore";
import MongoDBDataAdapterEntry from "../models/MongoDBDataAdapterEntry";
const DEFAULT_DATA = {
  entries: [],
  pagination: {
    total: 0,
    count: 0,
    page: 0,
    perPage: 0
  }
};
class MongoDBDataAdapterTable extends React.Component {
  constructor(props) {
    super(props);
    this.execSearch = () => {
      const { dataAdapterId } = this.props;
      const { query, page, perPage } = this.state;
      MongoDBDataAdapterActions.search(dataAdapterId, query, page, perPage);
    };
    this.handleSearch = (query) => {
      this.setState({ query, page: 1 }, () => {
        this.execSearch();
      });
    };
    this.handleSearchReset = () => {
      this.setState({ query: "", page: 1 }, () => {
        this.execSearch();
      });
    };
    this.handlePageChange = (page, perPage) => {
      this.setState({ page, perPage }, () => {
        this.execSearch();
      });
    };
    this.handleInput = (key) => (event) => {
      const newState = {};
      newState[key] = trim(event.target.value);
      this.setState(newState);
    };
    this.handleInputValues = (key) => (event) => {
      const newState = {};
      newState[key] = split(event.target.value, /\r?\n/);
      this.setState(newState);
    };
    this.clearValues = () => {
      this.setState({
        storeId: "",
        storeValues: [],
        storeKey: "",
        editMode: false,
        ttl: { value: 1, unit: "", enabled: false }
      });
    };
    this.clearValuesAndReloadEntries = () => {
      this.clearValues();
      this.execSearch();
    };
    // eslint-disable-next-line class-methods-use-this
    this.trimValues = (values) => uniq(values.map((value) => trim(value)).filter((value) => (value != null ? value : "").length > 0));
    this.addEntry = (e) => {
      var _a, _b;
      const { dataAdapterId } = this.props;
      const {
        storeId,
        storeKey,
        storeValues,
        ttl: { value: ttlValue, unit: ttlUnit, enabled: ttlEnabled },
        editMode
      } = this.state;
      (_a = e == null ? void 0 : e.preventDefault) == null ? void 0 : _a.call(e);
      (_b = e == null ? void 0 : e.stopPropagation) == null ? void 0 : _b.call(e);
      const newEntryBuilder = MongoDBDataAdapterEntry.builder().dataAdapterId(dataAdapterId).id(isEmpty(trim(storeId)) ? null : storeId).key(storeKey).values(this.trimValues(storeValues)).ttl(ttlEnabled ? ttlValue : null).ttl_unit(ttlEnabled ? ttlUnit : null);
      if (editMode) {
        MongoDBDataAdapterActions.update(newEntryBuilder.build()).then(this.clearValuesAndReloadEntries).catch(this._errorHandler("Cannot update entry", "Update failed"));
      } else {
        MongoDBDataAdapterActions.create(newEntryBuilder.build()).then(this.clearValuesAndReloadEntries).catch(this._errorHandler("Cannot create entry", "Creation failed"));
      }
    };
    // eslint-disable-next-line class-methods-use-this
    this._errorHandler = (message, title) => (error) => {
      let errorMessage;
      try {
        if (isArray(error.additional.body)) {
          const invalidFields = error.additional.body.map((e) => last(split(e.path, "."))).join(", ");
          errorMessage = `invalid fields: ${invalidFields}`;
        } else {
          errorMessage = error.additional.body.message;
        }
      } catch (_e) {
        errorMessage = error.message;
      }
      UserNotification.error(`${message}: ${errorMessage}`, title);
    };
    this.resetForm = () => {
      this.clearValues();
    };
    this.editEntry = (entry) => () => {
      this.setState({
        storeId: entry.id,
        storeKey: entry.key,
        storeValues: entry.values,
        ttl: { value: entry.ttl, unit: entry.ttlUnit, enabled: entry.ttl !== null },
        editMode: true
      });
    };
    this.removeEntry = (entry) => () => {
      MongoDBDataAdapterActions.delete(entry).then(this.execSearch).catch(this._errorHandler("Cannot delete entry", "Deletion failed"));
    };
    this.updateTTL = (value, unit, enabled) => {
      this._updateTTL(value, unit, enabled);
    };
    this._updateTTL = (value, unit, enabled) => {
      const { ttl: ttlState } = this.state;
      const ttlObj = ObjectUtils.clone(ttlState);
      if (enabled && value) {
        ttlObj.value = value;
        ttlObj.enabled = enabled;
      } else {
        ttlObj.value = null;
        ttlObj.enabled = false;
      }
      ttlObj.unit = enabled ? unit : null;
      this.setState({ ttl: ttlObj });
    };
    this.state = {
      query: "",
      page: 1,
      perPage: 10,
      storeId: "",
      storeKey: "",
      ttl: {
        value: 1,
        unit: "",
        enabled: false
      },
      storeValues: [],
      editMode: false
    };
  }
  componentDidMount() {
    this.execSearch();
  }
  render() {
    const { data, dataAdapterId } = this.props;
    const { pagination, entries = [] } = data;
    const entryList = entries.map((entry) => {
      const key = entry.id;
      const values = entry.values || [];
      const expires = entry.expire_after || null;
      const valueList = slice(values, 0, 5).map((value) => /* @__PURE__ */ React.createElement("li", { key: `value-list-item-${value}` }, '"', value, '"'));
      if (values.length > 5) {
        valueList.push(
          /* @__PURE__ */ React.createElement("li", { key: "truncated" }, "[...] ", /* @__PURE__ */ React.createElement("em", null, "(edit entry to see all values)"))
        );
      }
      return /* @__PURE__ */ React.createElement("tr", { key }, /* @__PURE__ */ React.createElement("td", null, entry.key), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement("ol", { style: { paddingInlineStart: "1.5em" } }, valueList)), /* @__PURE__ */ React.createElement("td", null, expires ? /* @__PURE__ */ React.createElement(Timestamp, { dateTime: expires }) : "Does not expire"), /* @__PURE__ */ React.createElement("td", { style: { width: "8.5em" } }, /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(Button, { id: `edit-entry-${key}`, onClick: this.editEntry(entry), bsSize: "xsmall", bsStyle: "info" }, "Edit"), /* @__PURE__ */ React.createElement(Button, { id: `remove-entry-${key}`, onClick: this.removeEntry(entry), bsSize: "xsmall", bsStyle: "danger" }, "Delete"))));
    });
    const {
      storeValues,
      storeKey,
      editMode,
      ttl: { unit: ttlUnit, value: ttlValue, enabled: ttlEnabled }
    } = this.state;
    if (dataAdapterId === "" || !dataAdapterId) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("h3", null, "Entries can be added once the data adapter has been created."));
    }
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
      LicenseCheck,
      {
        displayWarningContainer: true,
        bsStyle: "danger",
        title: "Modification of entries disabled",
        text: "The modification of entries in the database is disabled because there is no valid license installed."
      }
    ), /* @__PURE__ */ React.createElement(Row, { style: { marginBottom: 20 } }, /* @__PURE__ */ React.createElement("h3", { style: { marginBottom: 10 } }, "Create/update entries"), /* @__PURE__ */ React.createElement(
      Input,
      {
        type: "text",
        id: "lookup-key",
        label: "Key",
        value: storeKey,
        placeholder: "Enter key name here...",
        help: "The lookup key name",
        labelClassName: "col-sm-1",
        wrapperClassName: "col-sm-11",
        onChange: this.handleInput("storeKey")
      }
    ), /* @__PURE__ */ React.createElement(
      Input,
      {
        type: "textarea",
        id: "lookup-key-values",
        rows: 5,
        label: "Values",
        value: (storeValues || []).join("\n"),
        placeholder: "e.g. 127.0.0.1",
        help: "A list of values, one value per line.",
        labelClassName: "col-sm-1",
        wrapperClassName: "col-sm-11",
        onChange: this.handleInputValues("storeValues")
      }
    ), /* @__PURE__ */ React.createElement(
      TimeUnitInput,
      {
        label: "TTL",
        update: this.updateTTL,
        value: ttlValue,
        help: "Custom TTL for entries",
        unit: ttlUnit || "MINUTES",
        units: ["MILLISECONDS", "SECONDS", "MINUTES", "HOURS", "DAYS"],
        enabled: ttlEnabled,
        labelClassName: "col-sm-1",
        wrapperClassName: "col-sm-11"
      }
    ), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { smOffset: 1, sm: 11 }, /* @__PURE__ */ React.createElement(ButtonToolbar, null, /* @__PURE__ */ React.createElement(
      Button,
      {
        id: "submit-entry",
        disabled: isEmpty(this.trimValues(storeValues)) || storeKey === "",
        type: "button",
        onClick: this.addEntry,
        bsSize: "small",
        bsStyle: "primary"
      },
      editMode ? "Update entry" : "Add new entry"
    ), /* @__PURE__ */ React.createElement(Button, { id: "clear-entry", onClick: this.resetForm, bsSize: "small" }, "Clear form"))))), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement("h3", null, "Configured keys and values"), /* @__PURE__ */ React.createElement(
      PaginatedList,
      {
        onChange: this.handlePageChange,
        activePage: pagination == null ? void 0 : pagination.page,
        totalItems: pagination == null ? void 0 : pagination.total,
        pageSize: pagination == null ? void 0 : pagination.perPage,
        pageSizes: [10, 50, 100],
        useQueryParameter: false
      },
      /* @__PURE__ */ React.createElement(SearchForm, { onSearch: this.handleSearch, onReset: this.handleSearchReset, topMargin: 10 }),
      /* @__PURE__ */ React.createElement(Table, { striped: true, condensed: true, hover: true }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", null, "Key"), /* @__PURE__ */ React.createElement("th", null, "Values"), /* @__PURE__ */ React.createElement("th", null, "Expires At"), /* @__PURE__ */ React.createElement("th", null, "Action"))), /* @__PURE__ */ React.createElement("tbody", null, entryList))
    )));
  }
}
export default connect(MongoDBDataAdapterTable, { adapter: MongoDBDataAdapterStore }, (props) => ({
  ...props,
  data: props.adapter.data || DEFAULT_DATA
}));
